var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.74951 20C9.41252 20 10.0484 19.7366 10.5172 19.2678C10.986 18.799 11.2494 18.1631 11.2494 17.5001H6.24965C6.24965 18.1631 6.51303 18.799 6.98184 19.2678C7.45066 19.7366 8.08651 20 8.74951 20ZM9.99319 1.37477C10.0106 1.20097 9.99146 1.02545 9.9369 0.859513C9.88234 0.693581 9.79361 0.540926 9.67643 0.411394C9.55925 0.281861 9.41622 0.178327 9.25657 0.107468C9.09692 0.0366098 8.92418 0 8.74951 0C8.57484 0 8.40211 0.0366098 8.24246 0.107468C8.0828 0.178327 7.93977 0.281861 7.82259 0.411394C7.70541 0.540926 7.61668 0.693581 7.56212 0.859513C7.50756 1.02545 7.48839 1.20097 7.50583 1.37477C6.09306 1.66213 4.82301 2.42891 3.91074 3.54528C2.99847 4.66164 2.50004 6.05898 2.49986 7.50068C2.49986 8.87311 1.8749 15.0003 0 16.2502H17.499C15.6241 15.0003 14.9992 8.87311 14.9992 7.50068C14.9992 4.47585 12.8493 1.95099 9.99319 1.37477Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/NotificationIcon.06951a4376d4aa3cccb4da08dfa0f3ac.svg";
export { ForwardRef as ReactComponent };